function getToken() {
  try {
    const s = localStorage.getItem('sms_auth');
    return s ? JSON.parse(s)?.token : null;
  } catch { return null; }
}

function authHeaders() {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function req(method, path, body) {
  const res = await fetch(`/api${path}`, {
    method,
    headers: authHeaders(),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('application/json')) {
    throw new Error(`Server error (HTTP ${res.status})`);
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
}

export const api = {
  // Auth
  login: (email, password) => req('POST', '/auth/login', { email, password }),

  // Generic CRUD
  list:   (entity)          => req('GET',    `/${entity}`),
  create: (entity, data)    => req('POST',   `/${entity}`, data),
  update: (entity, id, data) => req('PUT',  `/${entity}/${id}`, data),
  remove: (entity, id)      => req('DELETE', `/${entity}/${id}`),

  // Users (admin)
  listUsers:  ()            => req('GET',    '/users'),
  createUser: (data)        => req('POST',   '/users', data),
  updateUser: (id, data)    => req('PUT',    `/users/${id}`, data),
  deleteUser: (id)          => req('DELETE', `/users/${id}`),
  changePassword: (id, currentPassword, newPassword) =>
    req('PUT', `/users/${id}/password`, { currentPassword, newPassword }),

  // Dashboard
  dashboard: () => req('GET', '/dashboard'),

  // Health / connectivity check (no auth needed)
  isOnline: async () => {
    try {
      const r = await fetch('/api/setup/status');
      const d = await r.json();
      return d?.configured === true;
    } catch { return false; }
  },
};
